import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';
import NavBar from '../../NavBar';
import { Footer } from '../../Footer/Footer';

import { AreaRatesSearch } from '../AreaRatesSearch';
import { AutoFinancing } from './AutoFinancing';
import { CreditTierTabs } from '../CreditTierTabs';
import { LoanTermTabs } from '../LoanTermTabs';
import { DownPaymentInput } from '../DownPaymentInput';
import { TradeInValueInput } from '../TradeInValueInput';
import { EstimateValueInput } from '../EstimateValueInput';
import { LoanAmount } from '../LoanAmount';
import { CheckRatesButton } from '../CheckRatesButton';
import { ResetRatesButton } from '../ResetRatesButton.js';
import { MinimizeOrFullScreenButton } from '../MinimizeOrFullScreenButton.js';

import { useLocalStorage } from '../../../CustomHooks/useLocalStorage.js';

import { ComparisonSummary } from '../../RatesSummary/ComparisonSummary';

import { checkUserFilterRates, setUserInfo } from '../../../actions/index.js';

import { getOrSetAnonymousUserId } from '../../../utils/index.js';

import { TOKEN, LOGOUT, handleSettingsClick } from '../../../constants/index.js';

import { DEFAULT_LOAN_TERM } from '../../../constants/Dashboard/Financing';

import { utm_email_type, LENDER_ZIP_MAP } from '../__fixtures__/utm_campaign_types.js';

import {
  NY,
  GOOD,
  CREDIT_SCORE_OBJ,
  state_rates_filter,
  zip_code_rates_filter,
} from '../../../constants/LoansCalculator';

import {
  AUTO_LOANS,
  AUTO_LOAN_RATES,
  LOAN_DETAILS,
} from '../../../constants/LoansCalculator/AutoLoans';

import './AutoFinancing.css';
import './index.css';

export const AutoLoans = () => {
  const [zipCode, setZipCode] = useState('12025');
  const [usState, setUsState] = useState(NY);

  const [houseOfWorshipZipCode, setHouseOfWorshipZipCode] = useState('');
  const [houseOfWorshipUsState, setHouseOfWorshipUsState] = useState(NY);
  const [employmentZipCode, setEmploymentZipCode] = useState('');
  const [employmentUsState, setEmploymentUsState] = useState(NY);

  const [selectedLoanTerms, setSelectedLoanTerm] = useState(DEFAULT_LOAN_TERM);
  const [selectedCreditTier, setSelectedCreditTier] = useState(GOOD);

  const [downPaymentValue, setDownPaymentValue] = useState(0);
  const [tradeInValue, setTradeInValue] = useState(0);
  const [estimateValue, setEstimateValue] = useState(0);
  const [loanAmountValue, setLoanAmountValue] = useState(0);

  const [checkRates, setCheckRates] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(true);

  const [segsList, setSegsList] = useState({ 'Select Savers Club': 'Select Savers Club' });
  const [isQuorumEligible, setIsQuorumEligible] = useState(true);

  const [value] = useLocalStorage(TOKEN);

  const dispatch = useDispatch();
  const { user, jwt, model, mileage, make, auto_type, year } = useSelector(
    ({
      userReducer: { user, jwt },
      residencyReducer,
      vehicleReducer: { model, year, auto_type, mileage, make },
    }) => ({
      user,
      jwt,
      residencyReducer,
      model,
      year,
      auto_type,
      mileage,
      make,
    }),
  );
  const [vehYear, setVehYear] = useState(year);
  useEffect(() => {
    if (value || jwt) {
      if (!localStorage.getItem(TOKEN)) {
        return;
      }
      const user = atob(localStorage.getItem(TOKEN)?.split('.')?.[1]);
      const parsedUser = JSON.parse(user);

      if (parsedUser) {
        const date = new Date(parsedUser.exp * 1000);
        const now = new Date();
        if (date < now) {
          handleSettingsClick[LOGOUT]?.(dispatch, parsedUser);
        }

        dispatch((dispatch) => setUserInfo(dispatch, parsedUser));
      }
    } else {
      const anonymousUserId = getOrSetAnonymousUserId();

      dispatch((dispatch) => setUserInfo(dispatch, { anonymousUserId }));
    }
  }, [value, jwt]);

  const utm_campaign = new URLSearchParams(window.location.search).get('utm_campaign');

  const utm_campaign_type_name = new URLSearchParams(window.location.search).get('utm_email_type');

  const utm_lender_name = new URLSearchParams(window.location.search).get('utm_lender_name');

  useEffect(() => {
    if (utm_campaign && utm_campaign_type_name) {
      const zipCodes = LENDER_ZIP_MAP[utm_lender_name];

      if (zipCodes && zipCodes.length && utm_email_type[utm_campaign_type_name]) {
        const currentNum = Math.floor(Math.random() * zipCodes.length);
        const currZipCode = zipCodes.find((_, index) => index === currentNum);

        handleUTMCampaignCheckRates({
          utm_email_type_name: utm_campaign_type_name,
          zipCode: currZipCode,
        });
      }
    }
  }, []);

  const handleZipCodeChange = (val) => {
    setZipCode((prevState) => {
      mixpanel.track('Auto_Loan_Calculator', {
        fieldInput: 'Zip Code',
        field_value: val,
      });
      if (val.length <= 5) {
        return val;
      }

      return prevState;
    });
  };

  const handleUsStateChange = (val) => {
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'US State',
      field_value: val,
    });
    setUsState(val);
  };

  const handleHouseOfWorshipZipCodeChange = (val) => {
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'House Of Worship Zip Code',
      field_value: val,
    });
    setHouseOfWorshipZipCode((prevState) => {
      if (val.length <= 5) {
        return val;
      }

      return prevState;
    });
  };

  const handleHouseOfWorshipStateChange = (val) => {
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'House of Worship US State',
      field_value: val,
    });
    setHouseOfWorshipUsState(val);
  };

  const handleEmploymentZipCodeChange = (val) => {
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Employment Zip Code',
      field_value: val,
    });

    setEmploymentZipCode((prevState) => {
      if (val.length <= 5) {
        return val;
      }

      return prevState;
    });
  };

  const handleEmploymentStateChange = (val) => {
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Employment US State',
      field_value: val,
    });

    setEmploymentUsState(val);
  };

  const handleLoanTerm = (loanTerm) => {
    setSelectedLoanTerm((prevState) => {
      if (prevState[loanTerm]) {
        const copyState = { ...prevState };
        delete copyState[loanTerm];

        mixpanel.track('Auto_Loan_Calculator', {
          fieldInput: 'Loan Terms',
          LOAN_TERMS: copyState,
        });

        return { ...copyState };
      }
      const updatedLoanTerms = { ...prevState, [loanTerm]: Number(loanTerm) };

      mixpanel.track('Auto_Loan_Calculator', {
        fieldInput: 'Loan Terms',
        LOAN_TERMS: updatedLoanTerms,
      });

      return updatedLoanTerms;
    });
  };

  const handleSelectCreditTier = (creditTier) => {
    setSelectedCreditTier(creditTier);

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'CREDIT TIER',
      CREDIT_TIER: creditTier,
    });
  };

  const handleDownPaymentChange = (value) => {
    setDownPaymentValue(value);
    const totalDepositValue = Number(value) + Number(tradeInValue);

    const NEW_LOAN_AMOUNT = Number(estimateValue) - Number(totalDepositValue);
    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Down Payment',
      DownPaymentValue: value,
      LoanAmountValue: NEW_LOAN_AMOUNT,
    });

    setLoanAmountValue(NEW_LOAN_AMOUNT);
  };

  const handleTradeInValueChange = (value) => {
    setTradeInValue(value);
    const totalDepositValue = Number(downPaymentValue) + Number(value);

    const NEW_LOAN_AMOUNT = Number(estimateValue) - totalDepositValue;

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Trade In Value',
      TradeInValue: value,
      LoanAmountValue: NEW_LOAN_AMOUNT,
    });

    setLoanAmountValue(NEW_LOAN_AMOUNT);
  };

  const handleEstimateValueChange = (value) => {
    setEstimateValue(value);

    const totalDepositValue = Number(downPaymentValue) + Number(tradeInValue);

    const NEW_LOAN_AMOUNT = Number(value) - totalDepositValue;

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Estimate Value',
      EstimateValue: value,
      LoanAmountValue: NEW_LOAN_AMOUNT,
    });

    setLoanAmountValue(NEW_LOAN_AMOUNT);
  };

  const handleUTMCampaignCheckRates = ({ utm_email_type_name, zipCode }) => {
    setCheckRates(true);
    setIsFullScreen(false);

    const anonymousUserId = getOrSetAnonymousUserId();

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Check Rates',
      [state_rates_filter]: usState,
      [zip_code_rates_filter]: zipCode,
      houseOfWorshipState: houseOfWorshipUsState,
      houseOfWorshipZipCode: houseOfWorshipZipCode,
      employmentUsState,
      employmentZipCode,
      loanAmount: 10000,
      credit_score: CREDIT_SCORE_OBJ[selectedCreditTier],
      creditTier: selectedCreditTier,
      loan_type: 'Auto',
      term_months: utm_email_type[utm_email_type_name].loanTerms,
      loanTerms: Object.values(selectedLoanTerms),
      vehicle_year: 2026,
      down_payment: 4000,
      user: { anonymousUserId },
      make: 'Toyota',
      model: 'Camry',
      mileage: 500,
      auto_type,
      segsList,
      isQuorumEligible,
      estimateValue: 6000,
      ...(utm_email_type[utm_email_type_name] || {}),
    });

    dispatch(
      checkUserFilterRates({
        body: {
          [state_rates_filter]: usState,
          [zip_code_rates_filter]: zipCode,
          houseOfWorshipState: houseOfWorshipUsState,
          houseOfWorshipZipCode: houseOfWorshipZipCode,
          employmentUsState,
          employmentZipCode,
          loanAmount: 10000,
          credit_score: CREDIT_SCORE_OBJ[selectedCreditTier],
          creditTier: selectedCreditTier,
          loan_type: 'Auto',
          term_months: utm_email_type[utm_email_type_name].loanTerms,
          loanTerms: utm_email_type[utm_email_type_name].loanTerms,
          vehicle_year: 2026,
          down_payment: 4000,
          user: { anonymousUserId },
          make: 'Toyota',
          model: 'Camry',
          mileage: 500,
          auto_type,
          segsList,
          isQuorumEligible,
          estimateValue: 6000,
          ...(utm_email_type[utm_email_type_name] || {}),
        },
        financingInfo: {
          financingType: 'Auto',
          selectedLoanTerms,
          selectedCreditTier,
          downPayment: 4000,
          tradeInValue,
          estimateValue: 6000,
          year: 2026,
          vehicleYear: 2026,
          make: 'Toyota',
          model: 'Camry',
          mileage: 500,
          auto_type,
          ...(utm_email_type[utm_email_type_name] || {}),
        },
        user: { anonymousUserId },
      }),
    );
  };

  const handleCheckRates = () => {
    setCheckRates(true);
    setIsFullScreen(false);

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Check Rates',
      [state_rates_filter]: usState,
      [zip_code_rates_filter]: zipCode,
      houseOfWorshipState: houseOfWorshipUsState,
      houseOfWorshipZipCode: houseOfWorshipZipCode,
      employmentUsState,
      employmentZipCode,
      loanAmount: loanAmountValue,
      credit_score: CREDIT_SCORE_OBJ[selectedCreditTier],
      creditTier: selectedCreditTier,
      loan_type: 'Auto',
      term_months: Object.values(selectedLoanTerms),
      loanTerms: Object.values(selectedLoanTerms),
      vehicle_year: vehYear,
      down_payment: downPaymentValue,
      user,
      make,
      model,
      mileage,
      auto_type,
      segsList,
      isQuorumEligible,
      estimateValue,
    });

    dispatch(
      checkUserFilterRates({
        body: {
          [state_rates_filter]: usState,
          [zip_code_rates_filter]: zipCode,
          houseOfWorshipState: houseOfWorshipUsState,
          houseOfWorshipZipCode: houseOfWorshipZipCode,
          employmentUsState,
          employmentZipCode,
          loanAmount: loanAmountValue,
          credit_score: CREDIT_SCORE_OBJ[selectedCreditTier],
          creditTier: selectedCreditTier,
          loan_type: 'Auto',
          term_months: Object.values(selectedLoanTerms),
          loanTerms: Object.values(selectedLoanTerms),
          vehicle_year: vehYear,
          down_payment: downPaymentValue,
          user,
          make,
          model,
          mileage,
          auto_type,
          segsList,
          isQuorumEligible,
          estimateValue,
        },
        financingInfo: {
          financingType: 'Auto',
          selectedLoanTerms,
          selectedCreditTier,
          downPayment: downPaymentValue,
          tradeInValue,
          estimateValue,
          year: vehYear,
          vehicleYear: vehYear,
          make,
          model,
          mileage,
          auto_type,
        },
        user,
      }),
    );
  };

  const handleResetRates = () => {
    setCheckRates(false);

    setUsState(NY);
    setZipCode('');
    setSelectedLoanTerm(DEFAULT_LOAN_TERM);
    setSelectedCreditTier(GOOD);
    setTradeInValue(0);
    setDownPaymentValue(0);
    setEstimateValue(0);
    setLoanAmountValue(0);

    mixpanel.track('Auto_Loan_Calculator', {
      fieldInput: 'Reset Rates',
    });
  };

  return (
    <div>
      <NavBar currentPath={AUTO_LOANS} />
      <div className="auto-loans-filter-results-rates-wrapper">
        {(!checkRates || isFullScreen) && (
          <div className="loans-calculator-content-wrapper">
            <div className="auto-loans-calculator-wrapper">
              <h2>{AUTO_LOAN_RATES}</h2>
              <div className="auto-loans-calculator-content-wrapper">
                <div className="minimize-or-fullscreen-button-wrapper">
                  <MinimizeOrFullScreenButton
                    checkRates={checkRates}
                    isFullScreen={isFullScreen}
                    setIsFullScreen={setIsFullScreen}
                    filter={'Auto_Loan_Calculator'}
                  />
                </div>

                <AreaRatesSearch
                  zipCode={zipCode}
                  onZipCodeChange={handleZipCodeChange}
                  usState={usState}
                  onUsStateChange={handleUsStateChange}
                  houseOfWorshipZipCode={houseOfWorshipZipCode}
                  onHouseOfWorshipZipCodeChange={handleHouseOfWorshipZipCodeChange}
                  houseOfWorshipUsState={houseOfWorshipUsState}
                  onHouseOfWorshipUsStateChange={handleHouseOfWorshipStateChange}
                  employmentZipCode={employmentZipCode}
                  onEmploymenZipCodeChange={handleEmploymentZipCodeChange}
                  employmentUsState={employmentUsState}
                  onEmploymentStateChange={handleEmploymentStateChange}
                  filter="Auto"
                  segsList={segsList}
                  setSegsList={setSegsList}
                  isQuorumEligible={isQuorumEligible}
                  setIsQuorumEligible={setIsQuorumEligible}
                />

                <h3 className="auto-loan-details-header">{LOAN_DETAILS}</h3>
                <AutoFinancing checkRates={checkRates} user={user} handleVehicleYear={setVehYear} />
                <LoanTermTabs
                  selectedLoanTerms={selectedLoanTerms}
                  handleLoanTermClick={handleLoanTerm}
                />
                <CreditTierTabs
                  selectedCreditTier={selectedCreditTier}
                  handleSelectCreditTier={handleSelectCreditTier}
                />

                <div className="loans-financing-field-row-wrapper">
                  <DownPaymentInput
                    downPaymentValue={downPaymentValue}
                    onDownPaymentChange={handleDownPaymentChange}
                  />
                  <TradeInValueInput
                    tradeInValue={tradeInValue}
                    onTradeInValueChange={handleTradeInValueChange}
                  />
                </div>
                <EstimateValueInput
                  estimateValue={estimateValue}
                  onEstimateValueChange={handleEstimateValueChange}
                />
                <LoanAmount loanAmountValue={loanAmountValue} />
                <div className="reset-check-rates-button-wrapper">
                  <ResetRatesButton onResetRates={handleResetRates} />
                  <CheckRatesButton
                    loanAmountValue={loanAmountValue}
                    onCheckRates={handleCheckRates}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {checkRates && (
          <div className="rates-comparison-summary-wrapper">
            <ComparisonSummary
              checkRates={checkRates}
              displayFooter={false}
              isFullScreen={isFullScreen}
              isRatesTableFullScreen={isFullScreen}
              setIsFullScreen={setIsFullScreen}
              user={user}
              usState={usState}
              tokenValue={jwt || value}
              vehicle={{
                Make: utm_email_type[utm_campaign_type_name]?.make,
                Model: utm_email_type[utm_campaign_type_name]?.model,
                Year: utm_email_type[utm_campaign_type_name]?.vehicle_year,
              }}
            />
          </div>
        )}
      </div>
      <Footer currentPath={'/auto_loans'} />
    </div>
  );
};
